import Loader from "@Common/Loader";
import { useAbTestComponent, loadLazyComponent } from "@hook";
import { inject, observer } from "mobx-react";
import Default from "./Default";

const abTests = {
    dev_4409__v2: loadLazyComponent(() => import("./AB_4409_v2_v4")),
    dev_4409__v3: loadLazyComponent(() => import("./AB_4409_v3")),
    dev_4409__v4: loadLazyComponent(() => import("./AB_4409_v2_v4")),
    dev_4409__v5: loadLazyComponent(() => import("./AB_4409_v5")),
    dev_3422__v2: loadLazyComponent(() => import("./AB_3422")),
    dev_2659__v2: loadLazyComponent(() => import("./AB_2659")),
    dev_3274__v2: loadLazyComponent(() => import("./AB_3274")),
    dev_3632__v2: loadLazyComponent(() => import("./AB_3274")),
};

const Modal = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default, LoadingComp: Loader }); // лоадер по дефолту можно не передавать. нужен на момент загрузки компонента аб-теста. подходит когда модалки грузим в самом начале приветственные

        return <Specified {...props} />;
    }),
);

export default Modal;
